// extracted by mini-css-extract-plugin
export default {"disCard":"disasterCard_disCard__158O2","info":"disasterCard_info__YE91n","cardBox":"disasterCard_cardBox__qEutE","dCardBtn":"disasterCard_dCardBtn__l2K10"};